export const renumerationModes = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL_BY_PARTNERS: 'MANUAL_BY_PARTNERS',
  MANUAL_BY_CLASSES: 'MANUAL_BY_CLASSES',
};
